/* @flow */

export const validation = {
  buttons: {
    min: 0,
    max: 2
  },
  headingMaxChar: 26,
  paragraphMaxChar: 150,
  modelMaxChar: 20,
  title: { required: true },
  socials: {
    min: 3,
    max: 5
  },
  slides: {
    min: 1,
    max: 15
  }
}

export const slickSliderSettings = {
  dots: false,
  autoplay: false,
  autoplaySpeed: 1000,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1
}
